// extracted by mini-css-extract-plugin
export default {"manage-substatuses-grid-container":"page_manage-substatuses-grid-container__KSugs","overflow-content":"page_overflow-content__KlG65"};